import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import {
  WebDomEcommerceLogo,
  WebDomFintechLogo,
  WebDomHealthcareLogo,
  CMSDomainEducation,
  CMSDomainGame,
  WebDomHospitalityLogo,
  CMSDomainAviation,
  WebDomEntertainmentLogo,
  WebDomRealEstateLogo,
  CMSDomainITStaff,
  WebDomOnDemandLogo,
  CMSDomainRetail,
  DigitalMarketingIndustryAuto,
  WebDomTourLogo,
  CMSDomainLogistics,
} from "../../../../app-constants";

function Domaindiversity() {
  return (
    <section
      className="domain_diversity p-100"
      style={{ background: "#F9F9F9" }}
    >
      <Container>
        <Row>
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <h2>
              Facilitating Diverse Industries as a Reliable{" "}
              <span>Custom CRM Development Company</span>
            </h2>
            <p>
              We specialize in versatile projects through our expertise in
              custom CRM development. That’s how we elevate our clients’
              operational efficiency by providing them with a CRM solution right
              according to their industry standards.
            </p>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <div className="domain_main">
              <div className="domain_item">
                <div className="domain_content">
                  {WebDomHealthcareLogo}
                  <h6>Healthcare</h6>
                </div>
              </div>
              <div className="domain_item">
                <div className="domain_content">
                  {WebDomFintechLogo}
                  <h6>Fintech</h6>
                </div>
              </div>
              <div className="domain_item">
                <div className="domain_content">
                  {DigitalMarketingIndustryAuto}
                  <h6>Automotive</h6>
                </div>
              </div>
              <div className="domain_item">
                <div className="domain_content">
                  {WebDomEcommerceLogo}
                  <h6>eCommerce</h6>
                </div>
              </div>
              <div className="domain_item">
                <div className="domain_content">
                  {CMSDomainLogistics}
                  <h6>Logistics</h6>
                </div>
              </div>
              <div className="domain_item">
                <div className="domain_content">
                  {WebDomHospitalityLogo}
                  <h6>Social Networking</h6>
                </div>
              </div>
              <div className="domain_item">
                <div className="domain_content">
                  {CMSDomainGame}
                  <h6>Game & Sports</h6>
                </div>
              </div>
              <div className="domain_item">
                <div className="domain_content">
                  {WebDomTourLogo}
                  <h6>Travel & Tourism</h6>
                </div>
              </div>
              <div className="domain_item">
                <div className="domain_content">
                  {CMSDomainAviation}
                  <h6>Aviation</h6>
                </div>
              </div>
              <div className="domain_item">
                <div className="domain_content">
                  {WebDomRealEstateLogo}
                  <h6>Real Estate</h6>
                </div>
              </div>
              <div className="domain_item">
                <div className="domain_content">
                  {CMSDomainEducation}
                  <h6>Education</h6>
                </div>
              </div>
              <div className="domain_item">
                <div className="domain_content">
                  {WebDomOnDemandLogo}
                  <h6>On-Demand</h6>
                </div>
              </div>
              <div className="domain_item">
                <div className="domain_content">
                  {WebDomEntertainmentLogo}
                  <h6>Music</h6>
                </div>
              </div>
              <div className="domain_item">
                <div className="domain_content">
                  {CMSDomainITStaff}
                  <h6>IT Staff Augmentation</h6>
                </div>
              </div>
              <div className="domain_item">
                <div className="domain_content">
                  {CMSDomainRetail}
                  <h6>Retail</h6>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Domaindiversity;
